import React from 'react';
import { ArrowRight } from 'lucide-react';

export const GlassButton = ({ children = "Comenzar", onClick }) => {
  return (
    <div className="relative group inline-block">
      {/* Resplandor de fondo (Glow effect) */}
      <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-500 to-white-600 rounded-xl blur opacity-30 group-hover:opacity-100 transition duration-500 group-hover:duration-200" />
      
      {/* Botón principal */}
      <button
        onClick={onClick}
        className="
          hidden sm:flex items-center gap-2 bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-white-700 hover:to-blue-700 text-white px-4 py-2 rounded-xl text-sm font-semibold shadow-md shadow-cyan-500/10 transition-all transform active:scale-95
          active:scale-[0.98]
        "
      >
				<ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
        <span className="bg-gradient-to-r from-white via-slate-200 to-slate-400 bg-clip-text text-transparent text-sm font-bold">
          {children}
        </span>
      </button>
    </div>
  );
};